<template>
  <div>
    <div class="sub-title">Members:</div>
    <el-table
      :data="members_as_array"
      style="width: 100%">
      <el-table-column
        label="Name"
        width="200">
        <template slot-scope="scope">
          <img class="user-mini-image"
            :src="scope.row.cachedProfilePic|defaultUserPic"
            width="32" height="32"
            :title="scope.row.cachedName" />
          {{scope.row.cachedName}}
        </template>
      </el-table-column>
      <el-table-column
        label="Admin"
        width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isAdmin ? 'primary' : 'success'">
            {{scope.row.isAdmin ? 'yes' : 'no'}}
          </el-tag>
        </template>
      </el-table-column>
      <!--<el-table-column
        label="Owner"
        width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isOwner ? 'primary' : 'success'">
            {{scope.row.isOwner ? 'yes' : 'no'}}
          </el-tag>
        </template>
      </el-table-column>-->
      <el-table-column
        label="Status"
        width="100">
        <template slot-scope="scope">
          <el-tag :type="['primary', 'success', 'danger'][scope.row.acceptOrDecline]">
            {{scope.row.acceptOrDecline == 0 ? 'pending...' : ''}}
            {{scope.row.acceptOrDecline == 1 ? 'accepted' : ''}}
            {{scope.row.acceptOrDecline == 2 ? 'declined' : ''}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="">
        <template slot-scope="scope">
          <div v-if="currentUserIsAdmin && !scope.row.isOwner">
            <el-button size="mini" type="danger"
              @click="onMemberRowDelete(scope.$index, scope.row)">
              <font-awesome-icon icon="trash" /> Remove
            </el-button>
            <template v-if="scope.row.isAdmin">
              <el-button size="mini" type="info"
                @click="onMemberMakeAdmin(scope.$index, scope.row, false)">
                <font-awesome-icon icon="lock" /> Make member
              </el-button>
            </template>
            <template v-else>
              <el-button size="mini" type="warning"
                @click="onMemberMakeAdmin(scope.$index, scope.row, true)">
                <font-awesome-icon icon="unlock" /> Make admin
              </el-button>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="currentUserIsAdmin" class="mt-6 shadow-none p-3 bg-light rounded">
      <user-invite
        class="m-2"
        invitation-type="Goal"
        :invitation-payload="{
          goalId: goalId,
          cachedName: goal_meta.name,
          cachedPicture: goal_meta.picture
        }" />
    </div>
    <p v-else>To invite users you must be an admin.</p>

    <!--
    <el-button
      :disabled="!currentUserIsAdmin"
      type="success"
      class="m-2"
      @click="onInviteButtonClick">
      <font-awesome-icon icon="user-plus" />
      Invite
    </el-button>
    -->

    <div class="mt-8">
      <div v-if="currentUserIsAdmin">
        <font-awesome-icon icon="check-circle" /> You are admin.
      </div>
      <div v-if="currentUserIsOwner">
        <font-awesome-icon icon="check-circle" /> You are owner.
      </div>
    </div>

  </div>
</template>

<script>
import GoalManagementMixin from "@/components/Mixins/GoalManagement"

export default {
  mixins: [ GoalManagementMixin ],
  props: {
    goalId: { required: true }
  },
  data: () => ({
  }),
  computed: {
    members_as_array() {
      /* TODO Use members model instead! */
      return Object.keys( this.goal_meta.members ).map( id => {
        return { $id: id, ...this.goal_meta.members[ id ] }
      })
    },
  },
  methods: {

    onMemberMakeAdmin(idx, row, isAdmin) {
      console.log("onMemberMakeAdmin", idx, row);
      this.$api.goal_update_user_permissions({
        goal_id: this.goalId,
        user_id: row.$id,
        isAdmin: isAdmin
      }).then(result => {
        // this.fullGoalClone.members[idx].isAdmin = isAdmin;
      })
    },

    onMemberRowDelete(idx, row) {
      console.log("onMemberRowDelete", idx, row);

      this.$api.goal_remove_member({
        goal_id: this.goalId,
        user_id: row.$id
      }).then(result => {
        console.log("REMOVED USER");
        // this.fullGoalClone.members.splice(idx, 1);
      });
    },

    // cloneLaneInfo() {
    //   // this.userGoalClone = Object.assign({}, this.goal);
    //
    //   /* Erforderlich um observer zu löschen */
    //   // this.userGoalClone.userPictureOverride =
    //     // this.goal.userPictureOverride;
    //
    //   this.fullGoalClone = Object.assign({}, this.goal_meta);
    //   this.fullGoalClone.tasks = {};
    //
    //   this.fullGoalClone.deadlineList = [];
    //   if ( this.goal_meta.deadlineList ) {
    //     this.goal_meta.deadlineList.forEach(item => {
    //       let date = item.date || moment.currentDate();
    //             // ? (
    //             //   typeof item.date === 'number'
    //             //   ? new Date(item.date)
    //             //   : item.date.toDate()
    //             // )
    //             // : new Date();
    //       this.fullGoalClone.deadlineList.push({ name: item.name, date: date });
    //     });
    //   }
    //
    //   // this.fullGoalClone.members = Object.assign({}, this.goal_meta.members);
    //   this.fullGoalClone.members = [];
    //   Object.keys(this.goal_meta.members).forEach(key => {
    //     this.fullGoalClone.members.push({ id: key, ...this.goal_meta.members[key] });
    //   });
    //
    //   // TODO: userPictureOverride, picture
    //
    //   console.log("Local clones for userinput:", this.fullGoalClone);
    //
    //   /*
    //   this.commitmentWeekdaysArray = [];
    //   let weekdays = this.userGoalClone.commitmentWeekdays
    //   for ( let i = 0; i < weekdays.length; i++) {
    //     if ( weekdays[i] === 'x' ) {
    //       this.commitmentWeekdaysArray.push( this.weekdays[i] )
    //     }
    //   }
    //   */
    // },

    // onEditCommitment() {
    //   this.cloneLaneInfo();
    //   this.commitmentModalOpen = true;
    // },

    /* onInviteButtonClick() {
      // this.membersSearchInput = '';
      // this.showUserInputField = true;

      this.$invite_prompt_goal().then(({ selection, done }) => {
        done();
      })
    }, */

    // querySearchAsync(queryString, cb) {
    //   // console.log("queryString", queryString);
    //
    //   this.$api.contact_query_by_string(queryString).then(cb);
    // },

    // onUpdateWeekdays() {
    //   // TODO: MOVE
    //   let str = '';
    //   for ( let i = 0; i < this.weekdays.length; i++) {
    //     str += ( this.commitmentWeekdaysArray.includes( this.weekdays[i] ) ) ? 'x' : '-';
    //   }
    //   this.userGoalClone.commitmentWeekdays = str;
    //   console.log("onUpdateWeekdays", str);
    // },
  },
}
</script>
